import { Text } from '@chakra-ui/react'
import { useHistory } from 'react-router-dom'
import { Button, Select } from 'uikit'
import { FilterFooter, FilterHeader, FilterStack } from 'uikit/layout'
import { styleTypeOptions } from '../Documents.constants'

export const DocumentFilter = ({
  totalItems,
  value = {},
  onChange,
  onReset,
}) => {
  const history = useHistory()

  const handleFilter = (field) => {
    const fieldName = Object.keys(field)[0]
    const filedValue = field[fieldName]

    onChange({ ...value, [fieldName]: filedValue || undefined })
  }

  const handleResetFilter = () => {
    onReset?.()
  }

  return (
    <>
      <FilterHeader>
        <Button width="100%" onClick={() => history.push(`/documents/new`)} colorPalette="orange">
          Создать документ
        </Button>
      </FilterHeader>
      <FilterStack>
        <Select
          name="removed"
          label="Состояние"
          placeholder="Выберите"
          value={value.removed}
          options={[
            {
              value: 'false',
              label: 'Активные',
            },
            {
              value: 'true',
              label: 'Архивные',
            },
          ]}
          onChange={(e) => handleFilter({ removed: e.value })}
        />
        <Select
          name="style"
          label="Тип"
          isClearable
          placeholder="Выберите"
          value={value.style}
          options={styleTypeOptions}
          onChange={(e) => handleFilter({ style: e.value })}
        />
      </FilterStack>
      <FilterFooter>
        <Button size="sm" width="100%" onClick={handleResetFilter}>
          Очистить фильтр
        </Button>
        <Text fontSize="0.8rem" color="gray.300" mt={2}>{`Найдено: ${totalItems}`}</Text>
      </FilterFooter>
    </>
  )
}
